module.exports = "/assets/data/3a20a050cef007e1a47da2fb0db2b6dc-LS6.data.json";